module.exports = __webpack_public_path__ + "static/media/twitter.6105c5b9.svg";